var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('blog-form',{key:_vm.id,attrs:{"blog-id":_vm.id}})}
var staticRenderFns = []

export { render, staticRenderFns }